import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { IAcceptInvitation } from '@app/features/auth/interfaces/auth.interface';
import { AuthService } from '@app/features/auth/services/auth.service';

@Component({
  standalone: true,
  selector: 'app-accept-invitation',
  imports: [CommonModule , NgOptimizedImage],
  templateUrl: './accept-invitation.html',
  styleUrl: './accept-invitation.scss'
})
export class AcceptInvitation implements OnInit {
  showExpired = signal<boolean>(false);
  errorMessage = signal<string>('');
  loader = signal<boolean>( false)
  constructor(private router: Router, private authService: AuthService, private route: ActivatedRoute) { }
  ngOnInit(): void {
    localStorage.clear();
    this.getInvitationData();
  }
  getInvitationData(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    this.loader.set(true)
    this.authService.verifyInvitationToken(token).subscribe({
      next: ((res : {success : boolean , data : IAcceptInvitation}) => {
        if (res.success === true) {
          const invitedData ={
             token : token,
             data : res.data
          }
          localStorage.setItem('invited_user_data' , JSON.stringify(invitedData))
          if (res.data.is_existing_user) {
            this.router.navigate(['/login']);
          } else {
            this.router.navigate(['/signup']);
          }
        }
      }),
     error: (err) => {
       this.showExpired.set(true)
       this.errorMessage.set(err.error.error)
      },
      complete :()=>{
        this.loader.set(false)
      }
    })
  }
}
